import makeStyles from '@mui/styles/makeStyles';

import {
  borderColor,
  darkGray,
  surfaceElevated,
  surfaceSecondary,
  teal900,
  textPrimary,
} from '@/theme/colors';

export const useStyles = makeStyles({
  formContent: {
    padding: '24px',
    backgroundColor: surfaceElevated,
  },
  iconContainer: {
    width: 64,
    height: 64,
    backgroundColor: '#FEF3C7',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 16px',
  },
  icon: {
    width: 32,
    height: 32,
    color: '#D97706',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: textPrimary,
    textAlign: 'center',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: 14,
    color: darkGray,
    textAlign: 'center',
    margin: '0 0 24px 0',
  },
  inputGroup: {
    marginBottom: 16,
  },
  label: {
    display: 'block',
    fontSize: 14,
    color: darkGray,
    marginBottom: 8,
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: `1px solid ${borderColor}`,
    borderRadius: 4,
    fontSize: 14,
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none',
      borderColor: teal900,
      boxShadow: `0 0 0 1px ${teal900}`,
    },
    '&:disabled': {
      backgroundColor: surfaceSecondary,
      color: darkGray,
    },
    '&::placeholder': {
      color: '#9CA3AF',
    },
  },
  inputError: {
    borderColor: '#DC2626',
    '&:focus': {
      borderColor: '#DC2626',
      boxShadow: '0 0 0 1px #DC2626',
    },
  },
  forgotPasswordLink: {
    display: 'block',
    textAlign: 'center',
    marginTop: 16,
  },
  forgotPasswordButton: {
    fontSize: 14,
    color: 'var(--brandPrimary)',
    cursor: 'pointer',
    textDecoration: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    font: 'inherit',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  errorMessage: {
    backgroundColor: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: 4,
    padding: 12,
    marginBottom: 16,
    textAlign: 'center',
  },
  errorText: {
    fontSize: 14,
    color: '#DC2626',
    margin: 0,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    borderTop: `1px solid ${borderColor}`,
    backgroundColor: surfaceSecondary,
  },
  differentEmailButton: {
    color: 'var(--brandPrimary)',
    fontSize: 12,
    fontWeight: 500,
    textTransform: 'uppercase',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 8,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  loginButton: {
    backgroundColor: teal900,
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
    padding: '10px 24px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#004544',
    },
    '&:disabled': {
      backgroundColor: '#D1D5DB',
      color: '#9CA3AF',
      cursor: 'not-allowed',
    },
  },
});
